module.exports = __webpack_public_path__ + "static/media/icon-user-alt.67f4f6f4.svg";